import { render } from "./OrganisationListView.vue?vue&type=template&id=b21d0218"
import script from "./OrganisationListView.vue?vue&type=script&lang=js"
export * from "./OrganisationListView.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__